import * as api from '../../services/smssignVerify'

export const FETCH_SMSSIGNVERIFYS= 'FETCH_SMSSIGNVERIFYS';



export const fetchSmssignVerifys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_SMSSIGNVERIFYS,
        payload: {
            promise: api.findSmssignverifys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/smssignVerify.js